import { store } from '../../redux/store';
import ApiBase from 'services/base/apiBase';
import { prepareUpdatedData } from '../../helpers/stateChanges';
import {
  SaveColleagues,
  SetColleaguesFilter
} from '../../redux/slices/colleagues';
import {
  Colleague,
  ColleagueFilters,
  ColleagueList
} from 'core/interface/colleagues';
import { t } from 'i18next';
import { enqueueSnackbar } from 'notistack';

export class ColleaguesService {
  private static readonly baseApi = new ApiBase<ColleagueList>();

  public static async getColleagues(params: ColleagueFilters): Promise<void> {
    try {
      const { dispatch } = store;
      const res = await this.baseApi.getAsync(`/account/`, params);
      dispatch(SaveColleagues(res));
      return res;
    } catch (error) {
      console.error('Error in getColleagues:', error);
    }
  }

  public static async updateColleagueRole(
    id: number,
    role: string
  ): Promise<Colleague | void> {
    try {
      const { dispatch, getState } = store;
      const res = await this.baseApi.updateAsync(`/account/${id}/`, { role });
      const prevState = (getState() as any).colleagues?.colleagues;
      if (prevState?.results) {
        dispatch(
          SaveColleagues({
            ...prevState,
            results: prevState.results.map((el: Colleague) =>
              el.id === id ? { ...el, ...res, role: res?.role ?? role } : el
            )
          })
        );
      }
      enqueueSnackbar(t('Role updated successfully'), {
        variant: 'success'
      });
      return res;
    } catch (error) {
      enqueueSnackbar(t('Failed to update role'), {
        variant: 'error'
      });
      console.error('Error in updateColleagueRole:', error);
    }
  }

  public static async deleteColleague(id: number): Promise<boolean | void> {
    try {
      const { dispatch, getState } = store;
      const res = await this.baseApi.deleteAsync(`/account/${id}/`);
      const updatedState = prepareUpdatedData(
        'delete',
        'colleagues',
        { id },
        'colleagues'
      );
      const currentPage =
        (getState() as any).colleagues?.filters?.page || 1;

      if (!updatedState?.results?.length && updatedState?.count && currentPage > 1) {
        dispatch(SetColleaguesFilter('page', currentPage - 1));
      }
      dispatch(SaveColleagues(updatedState));
      enqueueSnackbar(t('User deleted successfully'), {
        variant: 'success'
      });
      return res;
    } catch (error) {
      enqueueSnackbar(t('Failed to delete user'), {
        variant: 'error'
      });
      console.error('Error in deleteColleague:', error);
    }
  }
}
